import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { ALBUM_SUBTYPE_LABEL } from '../../../../../../../constants/albums';
import { getCelebratedPersonName } from '../helpers';
import { videoIsProcessed } from '../../../../../../../util/video';
import GreetingVideo from './GreetingVideo';
import Logo from '../../../../../../../components/global/Logo';

const propTypes = {
  headerless: PropTypes.bool.isRequired,
  album: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  greetingVideo: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

const GroupVideoContent = ({ headerless, album, greetingVideo }) => {
  const celebratedName = getCelebratedPersonName(
    album.album_subtype,
    album.root_album_folder.event_settings,
    false,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  const posessiveCelebratedName = getCelebratedPersonName(
    album.album_subtype,
    album.root_album_folder.event_settings,
    true,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  return (
    <Fragment>
      {!headerless && (
        <Fragment>
          <div className="mb-3">
            <Logo />
          </div>
          <h5 className="mb-1 text-center text-uppercase text-light">
            Welcome to
          </h5>
          <h2 className="mb-3 text-black text-center">
            {posessiveCelebratedName} Group Video
          </h2>
        </Fragment>
      )}
      <p className="h4 text-normal">
        <span className="text-extra-bold">{album.creator.name} </span> is
        building a Group Video for{' '}
        <span className="text-extra-bold">{posessiveCelebratedName}</span>{' '}
        {(ALBUM_SUBTYPE_LABEL[album.album_subtype] || 'Event').toLowerCase()}{' '}
        and needs your help!
      </p>
      {videoIsProcessed(greetingVideo) && (
        <Fragment>
          <p className="h4 text-normal">
            Watch video message from{' '}
            <span className="text-extra-bold text-primary">
              {album.creator.name}
            </span>
            :
          </p>
          <GreetingVideo greetingVideo={greetingVideo} className="mb-3" />
        </Fragment>
      )}
      <p className="h4 text-normal">
        Please record your video message for{' '}
        <span className="text-extra-bold text-primary">{celebratedName}</span>{' '}
        below:
      </p>
    </Fragment>
  );
};

GroupVideoContent.propTypes = propTypes;

export default GroupVideoContent;
